import React from "react";
import { Button, Modal } from "antd";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useTranslation } from "react-i18next";

const CropPicRender = ({ visible, crop, currFile, changeCrop, handleSubmit, onCancel }) => {
  const { t } = useTranslation(["upload", "common"]);

  return (
    <Modal
      visible={visible}
      className="cropImageModal"
      width="580px"
      getContainer={document.querySelector(".Home")}
      footer={null}
      onCancel={onCancel}
      maskClosable={false}
    >
      <h3>{t("Please select the proper position with portrait.")}</h3>
      <div className="crop-cont">
        <div id="crop">
          <img id="crop-pic" src={currFile ? currFile.videofileurl : ""} alt="dynamic" />
          <ReactCrop minWidth={50} minHeight={50} crop={crop} onChange={newCrop => changeCrop(newCrop)} />
        </div>
      </div>
      <Button type="primary" size="large" onClick={handleSubmit}>
        {t("common:Confirm")}
      </Button>
    </Modal>
  );
};

export default CropPicRender;
